<template>
  <v-container
    fluid    
    class="fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-card 
        width="500"
        align="center"
        justify="center"
        elevation=5
      >
        <v-card-title class="font-weight-bold">💡 중복 로그인 알림</v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text
          class="pt-8 black--text body-1"
        >        
          회원님의 아이디로 다른 환경에서의 로그인이 확인되었습니다.
          <br>
          현재 접속을 종료합니다.
        </v-card-text>
        <v-btn 
          class="mb-4"
          tile
          color="primary"          
          to="/"
        >
          확인          
        </v-btn>
      </v-card>    
    </v-row>    
  </v-container>  
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import jwtParser from "../mixins/jwtParser.js"

export default {
  async created() {    
    if (this.refreshToken) {
      const tokenInfo = jwtParser.parseJwt(this.refreshToken);
      this.$ga.event('로그인', '중복 로그인', tokenInfo.nameid);      
    } else {
      this.$ga.event('로그인', '중복 로그인');
    }
      
    this.logout();      
    await this.updateLoggedin();      
  },
  computed: {
    ...mapState([
      'refreshToken'
    ])
  },
  methods: {
    ...mapMutations([
      'logout'
    ]),
    ...mapActions([
      'updateLoggedin'
    ])
  }
}
</script>

